import window from 'window-or-global';
// TODO: remove jquery from here and from webpack config once CONFDEV-52616 is done.
// eslint-disable-next-line no-restricted-imports
import $ from 'jquery';

const POSITION_ABOVE = 1;
const POSITION_BELOW = 2;

function getPreferredPosition(spaceAvailable) {
	return spaceAvailable.below > spaceAvailable.above ? POSITION_BELOW : POSITION_ABOVE;
}

export default function placedropdown(anchor, dropdown, options) {
	const $dropdown = dropdown.jquery ? dropdown : $(dropdown);
	const spaceAvailable = window.AJS.Position.spaceAboveBelow(
		window.AJS.Rte.getEditorFrame(),
		anchor,
	);
	const offset = window.AJS.Rte.Content.offset(anchor);
	const winWidth = $(window).width();
	const overlap = Math.max($dropdown.width() + offset.left - winWidth, 0);
	const adjustX = (options && options.adjustX) || 0;
	const adjustY = (options && options.adjustY) || 0;
	const left = offset.left - overlap + adjustX;
	const heightRequired = $dropdown.outerHeight(true);
	const preferredPosition = getPreferredPosition(spaceAvailable);
	let top;
	if (preferredPosition === POSITION_ABOVE) {
		top = offset.top - heightRequired - adjustY;
	} else {
		top = offset.top + anchor.height() + adjustY;
	}

	dropdown.css({
		left,
		top,
		display: 'block',
	});
}
